/**
 * Created by Jasmine on 2018/7/6.
 */
import {observable} from "mobx"
import {request, apis} from '../../../utils/net'

const store = observable({
    printArr: [],        // 打印小票明细数组
    printedItems: [],    // 已打印小票id数组

    // 获取打印小票列表
    getList() {
        let promise = request({
            url: apis.getPrintList
        });

        promise.then(res => {
            this.printArr = res.list
        })

        return promise
    },

    // 标记已打印小票
    signPrinted() {
        let promise = request({
            url: apis.printed,
            method: 'POST',
            data: {
                list: JSON.stringify(this.printedItems)
            }
        });

        return promise
    }
})

export default store
